import React from "react";
import {
  Col,
  Row,
  Button,
  Label,
  Input,
  CardSubtitle,
} from "reactstrap";

export default function ModalFilterData({
  modalFilterDataControl,
  setModalFilterDataControl,
  eventSchedules,
  guestGroups,
  getFilteredData,
  getTypeText,
}) {
  const handleCancel = () => {
    setModalFilterDataControl({ ...modalFilterDataControl, open: false });
  };

  const handleApply = () => {
    if (getFilteredData) {
      getFilteredData();
    }
    setModalFilterDataControl({ ...modalFilterDataControl, open: false });
  };

  return (
    <div style={{ paddingBottom: '10px' }}>
      <Row style={{ marginBottom: 10 }}>
        <CardSubtitle>
          Filtrar Ações
        </CardSubtitle>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="orderBy" className="form-label">
            {`Ordenar por`}
          </Label>
          <Input
            id="orderBy"
            className="form-control"
            type="select"
            value={modalFilterDataControl.orderBy}
            onChange={(e) => setModalFilterDataControl({ ...modalFilterDataControl, orderBy: e.target.value })}
          >
            <option value="id">Id</option>
            <option value="description">Descrição</option>
            <option value="groupId">Grupo</option>
            <option value="scheduleId">Programação</option>
          </Input>
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="description" className="form-label">
            {`Descrição`}
          </Label>
          <Input
            id="description"
            className="form-control"
            type="text"
            value={modalFilterDataControl.description || ''}
            onChange={(e) => setModalFilterDataControl({ ...modalFilterDataControl, description: e.target.value })}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="scheduleId" className="form-label">
            {`Programação`}
          </Label>
          <Input
            id="scheduleId"
            className="form-control"
            type="select"
            value={modalFilterDataControl.scheduleId || ''}
            onChange={(e) => setModalFilterDataControl({ ...modalFilterDataControl, scheduleId: e.target.value })}
          >
            <option value="">Selecione</option>
            {eventSchedules && eventSchedules.map(s => (
              <option key={s.value} value={s.value}>{s.text}</option>
            ))}
          </Input>
        </Col>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="groupId" className="form-label">
            {`Grupo`}
          </Label>
          <Input
            id="groupId"
            className="form-control"
            type="select"
            value={modalFilterDataControl.groupId || ''}
            onChange={(e) => setModalFilterDataControl({ ...modalFilterDataControl, groupId: e.target.value })}
          >
            <option value="">Selecione</option>
            {guestGroups && guestGroups.map(g => (
              <option key={g.value} value={g.value}>{g.text}</option>
            ))}
          </Input>
        </Col>
      </Row>
      {renderTypeField()}
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%' }}>
            <div style={{ padding: 3 }}>
              <Button
                color="danger"
                onClick={handleCancel}
              >
                Cancelar
              </Button>
            </div>
            <div style={{ padding: 3 }}>
              <Button
                color="success"
                onClick={handleApply}
              >
                Aplicar
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );

  function renderTypeField() {
    if (!getTypeText) return null;

    return (
      <Row style={{ marginBottom: 10 }}>
        <Col lg={12}>
          <Label htmlFor="type" className="form-label">
            {`Tipo`}
          </Label>
          <Input
            id="type"
            className="form-control"
            type="select"
            value={modalFilterDataControl.type || ''}
            onChange={(e) => setModalFilterDataControl({ ...modalFilterDataControl, type: e.target.value })}
          >
            <option value="">Selecione</option>
            <option value="whatsapp">Whatsapp</option>
            <option value="whatsappOrganizer">Whatsapp Organizador</option>
          </Input>
        </Col>
      </Row>
    );
  }
}
